import { render, staticRenderFns } from "./BaseMinusCircleIcon.vue?vue&type=template&id=bba7aace"
import script from "./BaseMinusCircleIcon.vue?vue&type=script&lang=js"
export * from "./BaseMinusCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports